import { Autocomplete, Button, Dialog, DialogContent, DialogTitle, Stack, TextField, Typography } from "@mui/material";
import { useState } from "react";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import FundraisingCategorySelect from "./FundraisingCategorySelect";
import FundraisingDocumentsContext from "./FundraisingDocumentsContext";

interface Props {
  files: File[];
  onClose: () => void;
  onConfirm: (externalCategoryId: string | undefined, section: string) => void;
}

const FundraisingDocumentsUploadDialog = ({ files, onClose, onConfirm }: Props) => {
  const { documentsState } = useDefinedContext(FundraisingDocumentsContext);

  const [externalCategoryId, setExternalCategoryId] = useState<string | undefined>(undefined);
  const [section, setSection] = useState<string | null>(null);

  const isValid = Boolean(section);

  const handleApplyClick = () => {
    if (section) {
      onConfirm(externalCategoryId, section);
    }
  };

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        Upload {files.length} {files.length === 1 ? "file" : "files"}
      </DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <DialogContent>
        <Stack spacing={2}>
          <Stack spacing={1}>
            <Typography color="textSecondary">Select category</Typography>
            <FundraisingCategorySelect
              fullWidth
              externalCategoryId={externalCategoryId}
              onChange={setExternalCategoryId}
            />
          </Stack>

          <Stack spacing={1}>
            <Typography color="textSecondary">Select section or type a new section name</Typography>
            <Autocomplete
              freeSolo
              fullWidth
              options={[...documentsState.orderedSections]}
              renderInput={(params) => <TextField {...params} placeholder="Section" />}
              value={section}
              onInputChange={(_, newValue) => setSection(newValue || null)}
            />
          </Stack>
        </Stack>
      </DialogContent>
      <DialogButtons onCancel={onClose}>
        <Button variant="contained" onClick={handleApplyClick} disabled={!isValid}>
          Apply
        </Button>
      </DialogButtons>
    </Dialog>
  );
};

export default FundraisingDocumentsUploadDialog;
